// removed by extract-text-webpack-plugin
module.exports = {"view-organizations-table":"view-organizations-table","responsive-table-container":"responsive-table-container","div-wrapper":"div-wrapper","ReactTable":"ReactTable","rt-table":"rt-table","rt-thead":"rt-thead","rt-th":"rt-th","rt-tbody":"rt-tbody","rt-td":"rt-td","rt-tr-group":"rt-tr-group","-striped":"-striped","rt-tr":"rt-tr","-odd":"-odd","-highlight":"-highlight","-padRow":"-padRow","pagination-bottom":"pagination-bottom","-pagination":"-pagination","-pagination_button":"-pagination_button","nf-view-users-grid":"nf-view-users-grid","-header":"-header"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grids/PendingRequest/PendingRequest.scss
// module id = 5545
// module chunks = 1